<template>
  <div>
    <div
      v-if="wrongOrientation"
      class="please-rotate notification is-primary">
      {{ $t("common.pleaseRotate1") }} <strong>{{ $t("common.pleaseRotate2") }}</strong><br/><br/><br/>
      {{ $t("common.pleaseRotate3") }}
    </div>
    <div v-if="!wrongOrientation">
      <div
        class="image-container"
        :style="imageContainerStyle"
      >
        <img
          class="background-image"
          ref="backgroundImg"
          :src="imageUrl"
          :style="bgImageStyle"
          @load="onImageLoad"/>
        <div
          v-for="(zone, index) in attributes.zones"
          :key="index"
          :style="choiceStyles[index]"
        >
          <img
            :src="attributes.choices[values[index]].url"
            :style="imageStyles"
            @click="switchChoice(index)"
          />
        </div>
      </div>

      <div
        class="button is-default"
        v-if="isCorrect"
        @click="validate"
        :ref="onDisplaySuccessButton">
        {{ $t("common.congrats") }}&nbsp;<i class="fa fa-angle-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import PuzzleMixin from '@/mixins/Puzzle'
import ForceOrientationMixin from '@/mixins/ForceOrientation'

export default {
  name: 'SceneImagesChoiceOnImage',
  mixins: [PuzzleMixin, ForceOrientationMixin],
  props: ['attributes', 'number'],
  data () {
    return {
      imageWidth: 0,
      imageRatio: 1, // Ratio displayed comparing to original size (background)
      values: {} // index within zones -> index within choices
    }
  },
  created () {
    for (const index of this.attributes.zones.keys()) {
      this.values[index] = 0 // First choice at start
    }
  },
  computed: {
    choiceStyles () {
      const res = []
      for (const zone of this.attributes.zones.values()) {
        const x = this.imageRatio * zone.x
        const y = this.imageRatio * zone.y
        const style = {
          position: 'absolute',
          left: x.toString() + 'px',
          top: y.toString() + 'px'
        }
        res.push(style)
      }
      return res
    },
    imageStyles () {
      const width = this.imageRatio * this.attributes.choiceWidth
      const height = this.imageRatio * this.attributes.choiceHeight
      return {
        width: width.toString() + 'px',
        height: height.toString() + 'px'
      }
    },
    // Image container style: set the image width once loaded
    imageContainerStyle () {
      if (this.imageWidth === 0) {
        return {}
      }
      return {
        'max-width': this.attributes.imageWidthPercentage.toString() + '%'
      }
    },
    // Is the puzzle solved?
    isCorrect () {
      for (const [index, zone] of this.attributes.zones.entries()) {
        const value = this.values[index]
        if (this.attributes.choices[value].file !== zone.correctAnswer) {
          return false
        }
      }
      return true
    },
    // Image to display : base, or success?
    imageUrl () {
      return this.attributes.url
    }
  },
  methods: {
    // On loading image, retrieve the display scale ratio
    calcImageRatio () {
      const img = this.$refs.backgroundImg
      this.imageRatio = img.width / img.naturalWidth
      this.imageWidth = img.width
    },
    onImageLoad () {
      this.calcImageRatio()
      setTimeout(this.calcImageRatio, 300)
    },
    // Turn input to next choice
    switchChoice (index) {
      if (this.values[index] === this.attributes.choices.length - 1) {
        this.values[index] = 0
      } else {
        this.values[index] += 1
      }
    },
    onDisplaySuccessButton (el) {
      if (el) {
        this.playVictorySound()
      }
      setTimeout(function () {
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
      }, 500)
    },
    validate () {
      this.$store.dispatch('validateItem', {
        number: this.number
      })
    }
  },
  mounted () {
    this.onForceOrientationResize()
    window.addEventListener('resize', this.onForceOrientationResize, false)
  },
  unmounted () {
    window.removeEventListener('resize', this.onForceOrientationResize)
  }
}
</script>

<style scoped lang="sass">
  .image-container
    margin: auto
    margin-top: 20px
    position: relative
    .background-image
      display: block
      max-width: 100%
    img
      user-select: none

  .please-rotate
    margin-top: 150px

  .button.is-default
    margin: 0px 0px

</style>
